import React from "react";
import { Link } from "gatsby";

import "./news-tile.scss";

const NewsTile = ({ date, image, title, desc, link }) => {
   return (
      <Link to={link}>
         <div className="news-tile">
            <div className="news-tile__date">{date}</div>
            <div className="news-tile__image-wrapper">
               <img src={image} alt={title} className="news-tile__image" />
            </div>
            <h5 className="news-tile__title">{title}</h5>
            <p className="news-tile__desc">
               {desc.length > 128 ? `${desc.substring(0, 128)}...` : desc}
            </p>
         </div>
      </Link>
   );
};

export default NewsTile;
